
class DatasetRowModel {
  _value = {
    rows: [],
    columns: [],
  }

  constructor(columns, rows) {
    this._value.columns = columns;
    if (rows) {
      rows.forEach((row) => this.processRow(row));
    }
  }

  processRow(row) {
    this._value.rows.push({
      key: (() => {
        const scheme = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
        return scheme.replace(
          /[xy]/g,
          (c) => {
            const r = Math.random() * 16 | 0;
            return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
          }
        );
      })(),
      row,
    });
  }

  get value() {
    return this._value;
  }
}

class DesignAtomsVdpModel {
  dataFromTable;
  surfacesRawData;
  vdpDataSet = {
    SurfacesData: [],
  };

  constructor(
    dataFromTable,
    surfacesRawData,
  ) {
    this.dataFromTable = dataFromTable;
    this.surfacesRawData = surfacesRawData;
  }

  serialize() {
    return this.vdpDataSet;
  }

  addSurfacesData() {
    const surfacesData = new SurfacesData();
    this.vdpDataSet.SurfacesData.push(surfacesData);
  }

  setSurfaceBinding() {
    const surfaceIndexes = this.getSurfacesIndexes();
    this.vdpDataSet.SurfacesData.forEach((_, surfaceIndex) => {
      this.vdpDataSet.SurfacesData[surfaceIndex].SurfaceBinding.SurfaceNames = null;
      this.vdpDataSet.SurfacesData[surfaceIndex].SurfaceBinding.SurfaceIndexes = surfaceIndexes;
      this.vdpDataSet.SurfacesData[surfaceIndex].IterateOverSurfacesFirst = false;
    });
  }

  setData() {
    // TODO: Check on multi-page design
    const surfaceIndex = 0;

    this.dataFromTable.forEach((dataSheet) => {
      dataSheet.rows.forEach((rowObject) => {
        const surfaceData = new SurfaceData();
        Object.entries(rowObject.row).forEach(([key, value]) => {
          // TODO: Placeholders - maybe this is "{{ }}" template from any editor, but need to check
          surfaceData.Placeholders[key] = value;
          const columnType = this.getColumnType(key) || 'Text';
          surfaceData[key] = {
            [columnType]: value,
          };
        });
        if (!this.vdpDataSet.SurfacesData[surfaceIndex]) {
          this.addSurfacesData();
        }
        this.vdpDataSet.SurfacesData[surfaceIndex].Data.push(surfaceData);
      });
    });
  }

  getColumnType(columnKey) {
    let columnEntry = null;

    this.surfacesRawData.columnsTypes.find((columnsObject) => {
      columnEntry = Object.entries(columnsObject).find(([key, _]) => key === columnKey) || null;
      return !!columnEntry;
    });
    
    if (!!columnEntry) {
      const columnType = columnEntry[1];
      return columnType;
    } else {
      return null;
    }
  }

  getSurfacesIndexes() {
    const surfacesIndexes = [];
    console.log('this.surfacesRawData', this.surfacesRawData);
    this.surfacesRawData.surfaces.forEach((surfaceData) => {
      surfacesIndexes.push(surfaceData.index);
    });
    return surfacesIndexes;
  }

}

class SurfaceData {
  Surfaces = null;
  Placeholders = {};
}

class SurfacesData {
  SurfaceBinding = {
    SurfaceNames: null,
    SurfaceIndexes: [],
    IsSingleBinding: false,
  };
  Data = [];
  IterateOverSurfacesFirst = false;
}

class DesignAtomsService {
  apigateway;
  stateId;
  tenantId;
  ownerId;
  token;

  constructor(options) {
    this.apigateway = options.apigateway;
    this.stateId = options.stateId;
    this.token = options.token;
    this.tenantId = options.tenantId;
    this.ownerId = options.ownerId;
  }

  async getVdpData() {
    const method = "GET";
    const url = new URL(this.apigateway);
    url.pathname = `/api/atoms/v1/designs/${this.stateId}/vdp-data`;
    url.searchParams.set('privateStorageOwner', this.ownerId);
    url.searchParams.set('tenantId', this.tenantId);

    return await fetch(url.href, {
      method,
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${this.token}`,
      },
    }).then((res) => res.json());
  }

  async putVdp(dataset, surfaceData) {
    const method = "PUT";
    const url = new URL(this.apigateway);
    url.pathname = `/api/atoms/v1/designs/${this.stateId}/vdp-data`;
    url.searchParams.set('privateStorageOwner', this.ownerId);
    url.searchParams.set('tenantId', this.tenantId);

    const vdpDataSet = this.processDatasetToDesignAtomsModel(dataset, surfaceData);

    const body = {
      vdpDataSet,
      // TODO: Add vdpItemsData if needed
      // vdpItemsData: {},
    };

    return await fetch(url.href, {
      method,
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${this.token}`,
      },
      body: JSON.stringify(body),
    });
  }

  processDatasetToDesignAtomsModel(dataset, surfaceData) {
    const model = new DesignAtomsVdpModel(dataset, surfaceData);
    model.addSurfacesData();
    model.setSurfaceBinding();
    model.setData();
    const vdpDataSet = model.serialize();
    return vdpDataSet;
  }
};

class ProcessVdpData {
  rowData = {
    dataset: null,
    surfacesData: null,
  }

  fillDataset(loadedData, loadedSurfacesData) {
    this.rowData.dataset = loadedData.map((dataset) => {
      const datasetRow = new DatasetRowModel(dataset.columns, dataset.rows);
      return datasetRow.value;
    });
    this.rowData.surfacesData = loadedSurfacesData;
    return this.rowData;
  }
}